import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import * as constants from '../../constants'
import * as libraryControlActions from '../../actions/library_control'
import SemanticUiModal from '../modal';

import { CreateTemplateControlModalContent, CreateTemplateControlModalActions } from './create_template_control_components';
import UnwantedEventDescription from './unwanted_event_description'

import { getText, debounce } from '../../helpers';

import 'semantic-ui-css/semantic.min.css';
import '../../App.css';
import './index.css';

class CreateTemplateControlModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      translations: props.language.translations,
      control: { is_library_control: true, tag_list: [], risk_level: 'unwanted_event' },
      libraryControls: [],
      selectedLibraryControls: [],
      filters: {
        include_archived: false,
        search_term: "",
        page: 1
      },
      isfetchingLibraryControls: false
    }
  }

  componentDidMount = () => {
    this.getLibraryControls({ page: 1, custom_controls_only: false });
  }

  componentWillReceiveProps = (nextProps) => {
    this.handleLanguageChanges(nextProps);

    const prevActionType = this.props.library_control.action_type;
    const nextActionType = nextProps.library_control.action_type;
    if (prevActionType === nextActionType) return;

    this.handleGetLibraryControlsRequest(nextProps);
    this.handleGetLibraryControlsSuccess(nextProps);

  };

  handleLanguageChanges = (nextProps) => {
    if (nextProps.language !== this.props.language) {
      this.setState({
        translations: nextProps.language.translations
      })
    }
  }

  handleGetLibraryControlsRequest = (nextProps) => {
    const nextActionType = nextProps.library_control.action_type;

    if (nextActionType === constants.GET_LIBRARY_CONTROLS_REQUEST) {
      this.setState({ isfetchingLibraryControls: true });
    }
  }

  handleGetLibraryControlsSuccess = (nextProps) => {
    let { libraryControls, filters } = this.state;

    const nextActionType = nextProps.library_control.action_type;

    if (nextActionType === constants.GET_LIBRARY_CONTROLS_SUCCESS) {
      if (filters.page === 1) {
        libraryControls = nextProps.library_control.library_controls;
      } else {
        libraryControls = libraryControls.concat(nextProps.library_control.library_controls);
      }

      this.setState({ libraryControls, isfetchingLibraryControls: false });
    }
  }

  setAsSelectedControl = (selectedLibraryControl) => {
    let selectedLibraryControls = this.state.selectedLibraryControls
    const isAlreadySelected = selectedLibraryControls.some(({ id }) => id === selectedLibraryControl.id)

    if (isAlreadySelected) {
      selectedLibraryControls = selectedLibraryControls.filter(({ id }) => id !== selectedLibraryControl.id)
    } else {
      selectedLibraryControls.push(selectedLibraryControl)
    }
    this.setState({ selectedLibraryControls });
  }

  getLibraryControls = (filtersOverride = {}) => {
    let { filters } = this.state;
    filters = { ...filters, ...filtersOverride };
    this.props.getLibraryControls(filters);
  }

  getMoreLibraryControls = () => {
    const { filters } = this.state;
    filters.page++
    this.setState({ filters }, this.getLibraryControls)
  }

  debouncedGetLibraryControls = () => {
    this.getLibraryControlsTimer = debounce(this.getLibraryControls, 1000, this.getLibraryControlsTimer)()
  }

  handleSearchChange = (event, data) => {
    let { filters } = this.state;
    filters = { ...filters, search_term: data.value, page: 1 };
    this.setState({ filters, libraryControls: [] }, this.debouncedGetLibraryControls);
  }

  setAsSelectedCustomControl = (selectedCustomControl) => {
    let selectedCustomControls = this.state.selectedCustomControls
    const isAlreadySelected = selectedCustomControls.some(({ name }) => name === selectedCustomControl.name)

    if (isAlreadySelected) {
      selectedCustomControls = selectedCustomControls.filter(({ name }) => name !== selectedCustomControl.name)
    } else {
      selectedCustomControls.push(selectedCustomControl)
    }
    this.setState({ selectedCustomControls });
  }

  onSaveControl = () => {
    const { selectedLibraryControls, control } = this.state;
    const { risk_level: riskLevel } = control;
    this.props.createLibraryControlsByRiskLevel(selectedLibraryControls, riskLevel);
  }

  handleControlNameChange = (event) => {
    const { control } = this.state;
    control.name = event.target.value;
    this.setState({ control });
  }

  handleControlTagsChange = (_, { value }) => {
    const { control } = this.state;
    control.tag_list = value;
    this.setState({ control })
  }

  handleRiskLevelChange = (_, { value }) => {
    const { control } = this.state;
    if (control.risk_level === value) {
      control.risk_level = null;
    } else {
      control.risk_level = value;
    }

    if (control.is_library_control) {
      this.setState({ control });
    } else {
      const { workPhase, activity, hazard, unwantedEvent } = this.props;
      let { filters } = this.state;
      const { risk_level } = control;

      let risk_level_description;
      if (risk_level === 'work_phase' ) risk_level_description = workPhase;
      if (risk_level === 'activity' ) risk_level_description = `${workPhase} / ${activity}`;
      if (risk_level === 'hazard' ) risk_level_description = `${workPhase} / ${activity} / ${hazard}`;
      if (risk_level === 'unwanted_event' ) risk_level_description = `${workPhase} / ${activity} / ${hazard} / ${unwantedEvent}`;
    
      filters = { ...filters, page: 1 };
      this.setState({ control, filters });
    }
  }

  render() {
    const { selectedLibraryControls, control, isfetchingLibraryControls } = this.state;
    const { workPhase, activity, hazard, unwantedEvent, controlType } = this.props;
    const modalOptions = { className: "create-control-modal template-create-control-modal", size: "large" }
    const disableSave = control.is_library_control && selectedLibraryControls.length === 0;
    const headerText = controlType === "existing-preventative" ? "Create Default Template Preventative Control" : "Create Default Template Recovery Control";

    return (
      <SemanticUiModal
        modalOptions={modalOptions}
        header={
          <Fragment>
            <div>{getText(headerText)}</div>
            <UnwantedEventDescription workPhase={workPhase} activity={activity} hazard={hazard} unwantedEvent={unwantedEvent} />
          </Fragment>

        }
        content={
          <CreateTemplateControlModalContent
            control={this.state.control}
            libraryControls={this.state.libraryControls}
            selectedLibraryControls={this.state.selectedLibraryControls}
            handleSearchChange={this.handleSearchChange}
            getMoreLibraryControls={this.getMoreLibraryControls}
            setAsSelectedControl={this.setAsSelectedControl}
            handleControlNameChange={this.handleControlNameChange}
            handleControlTagsChange={this.handleControlTagsChange}
            handleRiskLevelChange={this.handleRiskLevelChange}
            instanceConfig={this.props.instanceConfig}
            workPhase={workPhase}
            activity={activity}
            hazard={hazard}
            unwantedEvent={unwantedEvent}
            isfetchingLibraryControls={isfetchingLibraryControls}
          />
        }
        actions={
          <CreateTemplateControlModalActions
            disableSave={disableSave}
            onSaveControl={this.onSaveControl}
            hideCreateControl={this.props.hideCreateControl}
          />
        }
        closeModal={this.props.hideCreateControl}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.language.language,
    library_control: state.library_control,
    instanceConfig: state.instance.instanceConfig,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getLibraryControls: (options) => {
      dispatch(libraryControlActions.getLibraryControls(options))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateTemplateControlModal);


// WEBPACK FOOTER //
// ./src/components/controls_component/create_template_control_modal.js